export default __webpack_public_path__ + "static/media/apple-logo.04e421b5.png";